<template>
  <div class="home">
    
    <div class="progress" :style="{width: `${progress*100}%`}">  {{$t('progress')}}: {{Math.round(progress*100)}}% </div>

    <div id="title">
      <img src="/img/icons/icon.png" />
      <h3 v-if="locale"> {{$t(step.name)}} </h3>
      <h3 v-else> SELECT LANGUAGE </h3>
    </div>

    <div id="text" v-if="locale">  
        <div  class="questions" v-for="(question, q) in step.questions" :key="question.name">
          
          <div class="question">
          {{$t(question.name)}}
          </div>

          <div class="answer">
            <vs-select  v-model="answers[q]" :required="!question.empty" :multiple="!!question.multiselect" > <!--  -->
              <!-- <vs-option v-if="step.type == 'score'" :value="-1" label="-">
                -
              </vs-option>   -->
              <vs-option v-for="answer in question.answers" :key="answer.name" 
                :value="step.type == 'score' ? answer.value : answer.name" :label="$t(answer.name)">
          
                {{$t(answer.name)}} 
                  
              </vs-option> 
            </vs-select>
          </div>
        </div>  
        <div class="actions">
          <div>
          <vs-button :disabled="!validForm" @click="nextStep" size="large" success>
            {{$t('submit')}}
          </vs-button> <br>
          </div>
        </div> 
    </div>
    <div id="text" v-else>  
        <div  class="questions"> 
          <div class="question">
            <a href="/en"> English </a>
          </div>

          <div class="answer"> 
          </div>
        </div>  
        <div  class="questions"> 
          <div class="question">
            <a href="/it"> Italian </a>
          </div>

          <div class="answer"> 
          </div>
        </div>  
        <div  class="questions"> 
          <div class="question">
            <a href="/fr"> French </a>
          </div>

          <div class="answer"> 
          </div>
        </div>  
        <div  class="questions"> 
          <div class="question">
            <a href="/es"> Spanish </a>
          </div>

          <div class="answer"> 
          </div>
        </div>  
        <div  class="questions"> 
          <div class="question">
            <a href="/tr"> Turkish </a>
          </div>

          <div class="answer"> 
          </div>
        </div>  
        <div class="actions">
          <div> 
          </div>
        </div> 
    </div>

          <vs-button  v-if="locale" border @click="restartQuiz" danger size="small" id="restart">
            {{$t('restart')}} 
            <i class='bx bx-reset'></i>
          </vs-button>
  </div>
</template>

<script>
// @ is an alias to /src 
import app_data from '../data/questions.js'; 

export default {
  name: 'Home',
  data:()=>({
    step: {},
    answers: [],
    value: '',
    profile: {}, 
    locale: null
  }),
  computed: {
    validForm() {
      if(!this.step) return false;
      if(!this.step.questions) return false;
      
      let i = 0;
      for(let question of this.step.questions) {
        if(!question.empty)  {
          if(this.answers[i] === this.step.base_value) return false;
        }
        i++;
      }
      return true;
    },
    progress() {
      if(!this.profile || !app_data) return 0;  
      return Object.keys(this.profile).length / Object.keys(app_data.steps).length;
    }
  },
  watch:{
    $route (to, from){
      let step_name = this.$route.params.step || app_data.start_from; 
      this.loadStep(step_name);
      this.profile = JSON.parse(window.localStorage.getItem('profile')||'{}');

      if(this.profile.end) { 
        let locale = this.locale ; 
        if(locale) { 
          if(locale != '/end') {
            this.$router.push('/'+this.locale+'/'+app_data.end_at); 
          }
        }
        else {
          this.$router.push('/'+app_data.end_at); 
        }
      }
    }
  }, 
  mounted() { 
    this.profile = JSON.parse(window.localStorage.getItem('profile')||'{}');
    let step_name = this.$route.params.step || app_data.start_from; 
    this.loadStep(step_name);

    this.locale = this.$route.params.locale;

    if(this.profile.end) { 
      let locale = this.locale ; 
      if(locale) { 
        if(locale != '/end') {
          this.$router.push('/'+this.locale+'/'+app_data.end_at); 
        }
      }
      else {
        this.$router.push('/'+app_data.end_at); 
      }
    }
     
  },
  methods: {
    nextStep(ev) {
      
      if(this.validForm) {
        ev.preventDefault();  
        let step_answer = this.step.base_value;
        
        //questo perchè le risposte da mostrare all'utente sono diverse da quelle scritte nel json
        //in questo modo si può fare un confronto per valore nel json
        //facendo riferimento al codice della risposta
        let step_answer_code = this.answers.map(a=>a).join(', '); 

        if(this.step.type == "answer" || this.step.type == "answer-list") { 
          step_answer = this.answers.map(a=>Array.isArray(a) ? a.map(ai=>this.$t(ai)).join(', ') : this.$t(a)).join(', '); 
        }

        if(this.step.type == "score") 
          step_answer = this.answers.reduce((x,y)=>x+y, this.step.base_value)


        let r = 0;
        let step_result;  
        for(let result of this.step.results) {
          
          if(this.step.type == "answer" || this.step.type == "answer-list") {
            if(result.value && step_answer_code != result.value ) continue;
          }
          if(this.step.type == "score") {
            if(result.value && step_answer > result.upTo) continue;
          }
          step_result = result;
        } 
        
        let description = step_result.description;

        if(description.indexOf('{answers}')!= -1) 
          description = description.replace('{answers}', step_answer);
        else if(description.indexOf('{answer}')!= -1)
          description = description.replace("{answer}", step_answer);
        else
          description = this.$t(description);
    
        this.profile[this.step.name] = description;
        this.updateProfile();

        if(step_result.next == app_data.end_at) {
          this.profile[app_data.end_at] = true;
          this.updateProfile();
        } 
         
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        }); 


        this.$router.push('/'+this.locale+'/'+step_result.next);
      }
    },
    loadStep(step_id) {  

      if(step_id == app_data.end_at) {
        console.log(this.profile.join('\n')); 
      }
      let step=app_data.steps[step_id];  

      if(!step) return;

      let answers = [];
      for(let question of step.questions) {
        answers.push(step.base_value);
      }
      
      this.answers = answers;
      this.step = step; 
      
    },
    updateProfile() {
      window.localStorage.setItem('profile', JSON.stringify(this.profile));
    },
    restartQuiz() { 
      if(confirm(this.$t('confirm.restart'))) {
        let profile_string = window.localStorage.setItem('profile', "");
        this.$router.push('/'+this.locale+'/'+app_data.start_from);
      }
    }
  }
}
</script>


<style lang="scss">
.home { 
  width: calc( 90vw - 20px );
  margin-top: calc( (100vw - ( 90vw - 20px ) ) /2 );
  margin-bottom: calc( (100vw - ( 90vw - 20px ) ) /2 );
  height: fit-content;
  max-width: 600px; 
  left: 50%; 
  // margin-top: calc(  ( 100vh - ( 90vh + 20px ) ) / 2 );
  // margin-left: calc(  ( 100vw - ( 90vw + 20px ) ) / 2 );
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0px 0px 30px -10px #ccc;

  .progress {
    height: 20px;
    width: 100%;
    top: 0;
    left: 0;
    text-align: right;
    transition-duration: .5s;
    font-size: 0.7em;
    border-top: 5px solid #46c93a; 
    position: absolute;
    white-space: nowrap;
  }

  #title {
    text-align: center; 
    padding-left: 30px;
    padding-right: 30px;
  }

  #restart {}
  
  .questions  {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;

    .question, .answer {
      flex: 50%;
      display: flex;
      align-items: center;

      padding: 10px 20px;
    }

    .question {
      justify-content: left;
    }
    .answer {
      justify-content: center;
    }

    .vs-select-content {
      max-width: 100%;
      widows: 100%;
    }
 

  }

  .actions {
    display: flex;
    justify-content: center;
    align-items: center; 
  }

  @media (max-width: 690px) {
    .questions {
      flex-direction: column;
      .question, .answer {
        flex: 100%;
      }
    }
  }
}
</style>